<template>
    <form v-if="searchType=='internal'" class="search-form" v-on:submit.prevent="search(searchManufacturerId, searchText,searchType ,1)">
        <select class="form-control mt-2 mb-2" v-model="searchManufacturerId">
            <option value="" selected>All Manufacturers</option>
            <option v-for="manufacturer in manufacturerItems" v-bind:value="manufacturer.id" v-bind:key="manufacturer.id">{{manufacturer.name}}</option>
        </select>
        <input class="form-control search-input mt-2 mb-2" v-model="searchText" placeholder="Part Number" />
        <button class="btn btn-dark btn-search mt-2 mb-2" v-show="!loading" type="submit" v-bind:disabled="searchManufacturerId == '' && searchText == ''" v-on:click.prevent="search(searchManufacturerId, searchText, searchType, 1)">Search</button>
        <a class="btn btn-dark btn-search mt-2 mb-2" v-show="loading" disabled><img style="max-height:24px;" src="@/assets/images/placeholders/loading.gif" /></a>
    </form>
    <form v-if="searchType=='external'" class="search-form" v-on:submit.prevent="search('', searchText, searchType ,1)">
        <input class="form-control search-input mt-2 mb-2" v-model="searchText" placeholder="Part Number" />
        <button class="btn btn-dark btn-search mt-2 mb-2" v-show="!loading" type="submit" v-bind:disabled="searchText == ''" v-on:click.prevent="search('', searchText, searchType, 1)">Search</button>
        <a class="btn btn-dark btn-search mt-2 mb-2" v-show="loading" disabled><img style="max-height:24px;" src="@/assets/images/placeholders/loading.gif" /></a>
    </form>
</template>

<script>
    export default {
        name: 'SearchContentPane',
        emits: ["searchRequest"], 
        props: {
            manufacturerItems: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            searchType: {
                type: String,
                default: () => {
                    return "internal"
                }
            },
            setMfrId: {
                type: String,
                default: () => {
                    return ""
                }
            },
            setText: {
                type: String,
                default: () => {
                    return ""
                }
            }
        },
        data() {
            return {
                searchManufacturerId: "",
                searchText: "",
                loading: false
            }
        },
        methods: {
            //sends the search out and modifies the page as needed to display results
            async search(searchManufacturerId, searchText, type, page) {
                await this.$router.isReady();
                this.$emit('searchRequest', searchManufacturerId, searchText, type, page);
            }
        },
        watch: {
            //watch these properties, if set or changed they should overide current content
            setMfrId: {
                handler(newMfrId) {
                    this.$data.searchManufacturerId = newMfrId
                }
            },
            setText: {
                handler(newText) {
                    this.$data.searchText = newText;
                }
            }
        },
        mounted() {
            //subscribes to search mutations
            this.unsubsearchcontentpane = this.$store.subscribe((mutation) => {
                switch (mutation.type) {
                    case "SEARCH_START":
                        this.loading = true;
                        break;
                    case "SEARCH_COMPLETE":
                        this.loading = false;
                        break;
                    case "CLEAR_SEARCH_LOAD":
                        this.loading = false;
                }
            });
        },
        beforeUnmount() {
            this.unsubsearchcontentpane();
        },
    };
</script>

<style scoped>
</style>